import { forwardRef } from 'react'
import { Merge } from '@ui-components-3/ui/lib/types'
import classNames from '@ui-components-3/ui/lib/utils/classNames'
import FormControlLabel from '@ui-components-3/ui/lib/components/FormControlLabel'
import Checkbox, { CheckboxProps } from '@ui-components-3/ui/lib/components/Checkbox'

type FormCheckboxProps = Merge<
  CheckboxProps,
  {
    label: string
    useDefaultMargins?: boolean
    className?: string
    buttonClassName?: string
  }
>

const FormCheckbox = forwardRef<HTMLInputElement, FormCheckboxProps>(
  ({ label = '', useDefaultMargins, className = '', buttonClassName = '', ...props }, ref) => {
    return (
      <FormControlLabel className={classNames('flex items-center gap-2', useDefaultMargins ? '' : 'ml-0 mr-0', className)}>
        <Checkbox ref={ref} {...props} className={buttonClassName} />
        {label}
      </FormControlLabel>
    )
  },
)
FormCheckbox.displayName = 'FormCheckbox'

export default FormCheckbox
